<template>
  <b-row class="global-spinner-container" align-v="center" align-h="center">
    <half-circle-spinner :animation-duration="speedAnimation" :size="sizeAnimation" :color="colorAnimation"/>
  </b-row>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    colorAnimation: { type: String, default: '#428bca' },
    sizeAnimation: { type: Number, default: 35 },
    speedAnimation: { type: Number, default: 1000 },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .global-spinner-container {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 10000;
  }
</style>



// WEBPACK FOOTER //
// src/components/utils/Spinner.vue